/**
 * @ngdoc services
 * @memberof mercury.modules.time
 * @name TimeRoles
 */
angular.module('mercury.modules.time.role')
.factory('TimeRoles', ["$resource", "settings", function($resource, settings) {
  var Roles = $resource(settings.mercHost + '/staff-roles/:id');

  /**
   * [getAllActive description]
   *
   * @memberof TimeRoles
   * @return {?} [description]
   */
  function getAllActive() {
    return Roles.query({includeDeleted: false}).$promise;
  }

  /**
   * [getAll description]
   *
   * @memberof TimeRoles
   * @return {?} [description]
   */
  function getAll() {
    return Roles.query().$promise;
  }

  return {
    getAllActive: getAllActive,
    getAll: getAll
  };
}]);
